<template>
  <div class="detail-feedback">
    <div v-if="eventInfo.schedule !== '-1'">
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.totalStoreTraffic') }}</div>
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.disposable') }}</div>
          <van-field v-model="feedbackInfo.disposable" :disabled="eventInfoObj.isDisable" type="digit" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.openSystem') }}</div>
          <van-field v-model="feedbackInfo.openSystem" :disabled="eventInfoObj.isDisable" type="digit" placeholder="" :border="false" class="custom-field" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.otherCategory') }}</div>
          <van-field v-model="feedbackInfo.otherCategory" :disabled="eventInfoObj.isDisable" type="digit" placeholder="" :border="false" class="custom-field" />
        </div>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.newBuyersReOrderStoreCount') }}</div>
        </div>
        <div class="form-item" v-for="(brandItem) in projectBuyList" :key="brandItem.projectId">
          <div class="label custom-label square">
            <span>{{ brandItem.projectName }}</span>
          </div>
          <div class="brand-item">
            <div class="product-listing">
              <div class="listing-product">
                <div class="quantity-item">
                  <div class="title">{{ $t('form.newBuyers') }}</div>
                  <div class="stepper-custom">
                    <div class="step-btn" @click="handleStep(-5, brandItem, 'firstBuys')">-5</div>
                    <div class="step-btn" @click="handleStep(-1, brandItem, 'firstBuys')">-</div>
                    <van-field class="step-value" v-model.number="brandItem.firstBuys" :disabled="eventInfoObj.isDisable" type="digit" :border="false" />
                    <div class="step-btn" @click="handleStep(1, brandItem, 'firstBuys')">+</div>
                    <div class="step-btn" @click="handleStep(5, brandItem, 'firstBuys')">+5</div>
                  </div>
                </div>
                <div class="quantity-item">
                  <div class="title">{{ $t('form.reorderBuyers') }}</div>
                  <div class="stepper-custom">
                    <div class="step-btn" @click="handleStep(-5, brandItem, 'reorderBuys')">-5</div>
                    <div class="step-btn" @click="handleStep(-1, brandItem, 'reorderBuys')">-</div>
                    <van-field class="step-value" v-model.number="brandItem.reorderBuys" :disabled="eventInfoObj.isDisable" type="digit" :border="false" />
                    <div class="step-btn" @click="handleStep(1, brandItem, 'reorderBuys')">+</div>
                    <div class="step-btn" @click="handleStep(5, brandItem, 'reorderBuys')">+5</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.productDailySales') }}</div>
        </div>
        <div class="form-item" v-for="(brandItem, brandIndex) in productSaleList" :key="brandIndex">
          <div class="label custom-label square">
            <span>{{ brandItem.projectName }}</span>
          </div>
          <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
            <div class="product-status">
              <XuSelect v-model="subItem.productId" placeholder="Please select a product" :dataOptions="filteredOptions(brandItem, subItem.productId)" :fieldNames="{label: 'productName', value: 'productId'}" />
              <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
            </div>
            <div class="product-listing">
              <div class="listing-product">
                <div class="quantity-item">
                  <div class="title">{{ $t('form.salesPcs') }}</div>
                  <div class="stepper-custom">
                    <div class="step-btn" @click="handleStep(-5, subItem, 'sale')">-5</div>
                    <div class="step-btn" @click="handleStep(-1, subItem, 'sale')">-</div>
                    <van-field class="step-value" v-model.number="subItem.sale" type="digit" :border="false" />
                    <div class="step-btn" @click="handleStep(1, subItem, 'sale')">+</div>
                    <div class="step-btn" @click="handleStep(5, subItem, 'sale')">+5</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="add-more" @click="handleAdd('productSaleList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.pO') }}</div>
          <van-uploader v-model="feedbackInfo.poImgUrl" :disabled="eventInfoObj.isDisable" :after-read="(files, detail) => afterRead(files, detail, 'poImgUrl')" />
        </div>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.promotionEffect') }}</div>
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.eventFeedback') }}</div>
          <van-field v-model="feedbackInfo.eventFeedback" type="textarea" show-word-limit rows="3" :disabled="eventInfoObj.isDisable" placeholder="" :border="false" class="custom-field field-textarea" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.otherCosts') }}</div>
          <van-field v-model="feedbackInfo.otherCosts" type="textarea" show-word-limit rows="3" :disabled="eventInfoObj.isDisable" placeholder="" :border="false" class="custom-field field-textarea" />
        </div>
        <div class="form-item">
          <div class="label">{{ $t('form.eventPhotos') }}</div>
          <van-uploader v-model="feedbackInfo.imgUrl" :disabled="eventInfoObj.isDisable" :after-read="(files, detail) => afterRead(files, detail, 'imgUrl')" />
        </div>
      </div>
    </div>
    <div v-else class="summary-content">
      <div class="summary-title">
        <van-icon name="info-o" class="tip-icon" />
        <span>{{ $t('shared.titleSeven') }}</span>
      </div>
      <div class="info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.totalStoreTraffic') }}</div>
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.disposable') }}：</span>
          <span class="show-value">{{ summaryData.disposable }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.openSystem') }}：</span>
          <span class="show-value">{{ summaryData.openSystem }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
        <div class="item-content">
          <span class="show-name">{{ $t('form.otherCategory') }}：</span>
          <span class="show-value">{{ summaryData.otherCategory }}</span>
          <img class="label-icon" src="@/assets/images/slash_arrow.png" alt="" @click="handleTips">
        </div>
      </div>
      <div class="info summary-info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.newBuyersReOrderStoreCount') }}</div>
        </div>
        <div class="brand-section" v-for="(brandItem, brandIndex) in summaryData.projectBuyList" :key="brandIndex">
          <div class="brand-title square">
            <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }}</span>
          </div>
          <div class="quantity-content">
            <div class="qt-item jin">{{ $t('form.newBuyers') }}：<span class="pcs-num">{{ brandItem.firstBuys ? brandItem.firstBuys : $t('shared.filter.unknown') }}</span></div>
            <div class="qt-item jin">{{ $t('form.reorderBuyers') }}：<span class="pcs-num">{{ brandItem.reorderBuys ? brandItem.reorderBuys : $t('shared.filter.unknown') }}</span></div>
          </div>
        </div>
      </div>
      <div class="info summary-info">
        <div class="header-title item-title">
          <div class="blue-bar"></div>
          <div class="title-text">{{ $t('form.totalProductSales') }}</div>
        </div>
        <div class="item-info">
          <div class="custom-section" v-for="(brandItem, brandIndex) in summaryData.productSaleList" :key="brandIndex">
            <div class="section-title square">
              <span style="flex: 1;">{{ brandItem.projectName }}</span>
              <span>{{ $t('form.total') }}：<span class="pcs-num">{{ calculateTotalQuantity(brandItem.productList) }}</span> {{ $t('form.pcs') }}</span>
            </div>
            <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex" class="product-item">
              <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
              <div>{{ subItem.productName }}：<span class="pcs-num">{{ subItem.sale }} </span>{{ $t('form.pcs') }}</div>
            </div>
          </div>
          <!-- <div class="custom-section" v-if="visitInfo.imgMap && visitInfo.imgMap.sellIn.length > 0">
            <div class="sell-in-photo">
              <div class="photo-item">
                <span class="item-left">Photo</span>
                <span class="item-right">
                  <img v-for="(subItem, subIndex) in visitInfo.imgMap.sellIn" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.sellIn)">
                </span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover, Toast, Dialog } from 'vant'
import { eventSdFeedbackInfoApi, eventSdFeedbackSummaryApi } from '@/api/event'
import { mapState } from 'vuex'
export default {
  components: {
    [Popover.name]: Popover,
    XuSelect: () => import('@/components/XuSelect')
  },
  props: {
    currentSchedule: {
      type: Object,
      default: () => {}
    },
    eventInfoObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      feedbackInfo: {
        imgUrl: [],
        poImgUrl: []
      },
      projectBuyList: [],
      productSaleList: [],
      summaryData: {}
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    ...mapState({
      globalData: 'globalData'
    }),
    filteredOptions () {
      return (brandItem, currentId) => {
        if (!brandItem.currentProductList || !brandItem.productList) return []
        const selectedIds = brandItem.productList.map(item => item.productId).filter(id => id && id !== currentId)
        return brandItem.currentProductList.filter(item => !selectedIds.includes(item.productId))
      }
    }
  },
  created () {
    // console.log('feedback-created')
  },
  activated () {
    // console.log('feedback-activated')
  },
  mounted () {
    // this.getFeedbackInfo()
    // this.getSummaryInfo()
  },
  methods: {
    calculateTotalQuantity (productList) {
      if (!productList || productList.length === 0) {
        return 0
      }
      return productList.reduce((total, item) => {
        return total + (Number(item.sale) || 0)
      }, 0)
    },
    getFeedbackInfo () {
      if (this.eventInfo.schedule === '-1') return
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // xxx
      eventSdFeedbackInfoApi(this.eventInfo.eventId, this.eventInfo.schedule).then(res => {
        Toast.clear()
        const { feedback, projectBuyList, productSaleList } = res.data
        this.projectBuyList = projectBuyList
        productSaleList.forEach(subItem => {
          subItem.currentProductList = subItem.productList
          subItem.productList = subItem.productList.filter(filItem => {
            return filItem.inputId
          })
        })
        this.productSaleList = productSaleList
        this.feedbackInfo = {
          ...feedback,
          imgUrl: this.imgFormat(feedback.imgUrl),
          poImgUrl: this.imgFormat(feedback.poImgUrl)
        }
      })
    },
    imgFormat (arr) {
      let newArr = []
      if (arr && arr.length > 0) {
        newArr = arr.split(',').map(subItem => {
          return { url: subItem }
        })
        return newArr
      } else {
        return []
      }
    },
    getSummaryInfo () {
      // xxx
      eventSdFeedbackSummaryApi(this.eventInfo.eventId).then(res => {
        this.summaryData = res.data
      })
    },
    handleTips () {
      Dialog.alert({
        message: this.$t('tips.messageEight'),
        confirmButtonText: this.$t('button.gotIt'),
        confirmButtonColor: '#307bff'
      }).then(() => {
        // on close
      })
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.feedbackInfo[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    handleStep (delta, params, typeKey, obj = {}) {
      if (this.eventInfoObj.isDisable) return
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        this.$set(params, typeKey, newQuantity)
      }
    },
    handleDel (params, index) {
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    handleAdd (type, params = {}) {
      if (this.eventInfoObj.isDisable) return
      if (params.currentProductList.length === params.productList.length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'productSaleList') {
        params.productList.push({
          productId: '',
          sale: ''
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.detail-feedback {
  .info {
    margin-bottom: 20px;
    .header-title {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .blue-bar {
        width: 5px;
        height: 16px;
        background-color: #307bff;
        margin-right: 5px;
      }
      .title-text {
        font-weight: bold;
        font-size: 14px;
        color: #333;
      }
    }
    .item-content {
      display: flex;
      padding: 0 10px;
      align-items: center;
      line-height: 10px;
      margin-bottom: 10px;
      font-size: 14px;
      .show-value {
        color: #307bff;
        font-weight: bold;
      }
    }
    .item-title {
      margin-bottom: 10px;
    }

    .label-icon {
      width: 16px;
      height: 16px;
      margin-left: 3px;
    }
    .form-item {
      padding: 0 10px;
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
      }
      .custom-label {
        font-weight: bold;
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 5px;
          .listing-label {
            font-size: 13px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            background-color: #f7f7f7;
          }
        }
        .listing-title {
          margin-top: 10px;
          font-size: 13px;
          color: #7f7f7f;
        }
        .listing-product {
          .checkout-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 12px;
            color: #7f7f7f;
            /deep/.van-checkbox__label {
              color: #7f7f7f;
            }
            .total-pcs {
              color: #307bff;
            }
          }
          .quantity-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 5px;
            .title {
              width: 186px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
          /deep/.van-checkbox {
            .van-checkbox__label {
              margin-left: 3px;
            }
            .van-checkbox__icon {
              height: auto;
            }
          }
        }
      }
      .stepper-custom,
      .total-count {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .field-textarea {
        min-height: 100px;
      }
      .add-more {
        display: inline-block;
        padding: 5px;
        font-size: 12px;
        color: #307bff;
        border: 1px solid #307bff;
        background-color: #e4eefc;
        border-radius: 6px;
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .summary-content {
    .summary-title {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #307bff;
      padding: 0 10px;
      margin-bottom: 10px;
      .tip-icon {
        margin-right: 4px;
      }
    }
    .show-name {
      font-size: 12px;
    }
  }
  .brand-section {
    .brand-title {
      display: flex;
      align-items: center;
      padding: 10px 0;
      &.square {
        font-weight: bold;
        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background-color: #307bff;
          // position: absolute;
          // left: 0;
          // top: 0;
          transform: rotate(45deg);
          margin-right: 5px;
        }
      }
    }
    .quantity-content {
      padding: 10px;
      background-color: #f7f7f7;
      border-radius: 8px;
      .qt-item {
        margin-bottom: 8px;
        color: #7f7f7f;
        &:last-child {
          margin-bottom: 0;
        }
        &.jin {
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .summary-info {
    .brand-section {
      padding: 0 10px;
    }
  }
  .item-info {
    padding: 0px 12px;
    .custom-section {
      padding: 10px 0;
      border-bottom: 1px solid #e8effc;
      .product-item {
        display: flex;
        align-items: center;
        padding-top: 10px;
        .jt-icon {
          width: 9px;
          height: 12px;
          margin-right: 5px;
        }
      }
      .img-right {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
      }
      .desc-info {
        margin-top: 10px;
        color: #7f7f7f;
      }
    }
    .section-title,
    .brand-title {
      display: flex;
      align-items: center;
      &.square {
        font-weight: bold;
        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background-color: #307bff;
          // position: absolute;
          // left: 0;
          // top: 0;
          transform: rotate(45deg);
          margin-right: 5px;
        }
      }
    }
    .brand-section {
      .brand-title {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
      }
      .quantity-content {
        padding: 10px;
        background-color: #f7f7f7;
        border-radius: 8px;
        .qt-item {
          margin-bottom: 8px;
          color: #7f7f7f;
          &:last-child {
            margin-bottom: 0;
          }
          &.jin {
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
        }
      }
    }
    .sell-in-photo {
      .photo-item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e8effc;
        &:last-child {
          border-bottom: none;
        }
        .item-left {
          width: 126px;
        }
        .item-right {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
      }
    }
  }
  /deep/.van-field--disabled {
    background-color: #ebedf0 !important;
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
}

</style>
